import { CompanyEvents } from './company_events';
import { Reservations } from './reservations';

export const Calendar = {
  en: {
    ...Reservations.en,
    ...CompanyEvents.en,

    'Booking calendar': 'Booking calendar',
    Today: 'Today',
    'No location available': 'No location available',
    'No specialists scheduled': 'No specialists scheduled for this day',
    'New booking': 'New booking',

    // Entry-dialog tabs.
    tab_booking: 'Booking',
    Block: 'Block',

    'Block time': 'Block time',
    'Leave a comment': 'Leave a comment',
    'Edit block': 'Edit block',
    'Remove block': 'Remove block',
    'Edit comment': 'Edit comment',
    'Remove comment': 'Remove comment',
    Comment: 'Comment',
    Text: 'Text',
    Blocked: 'Blocked',
    'Group session': 'Group session',
    'Group session at another location': 'Group class at another location',
    'Busy at another location': 'Busy at another location',

    tab_group: 'Group class',
    'New group class': 'New group class',
    'Class details': 'Group class',
    'Recurring class': 'Recurring class',
    'Create class': 'Create class',
    'Create schedule': 'Create schedule',
    'Edit class': 'Edit class',
    'Cancel class': 'Cancel class',
    'Start time': 'Start time',
    Duration: 'Duration',
    Spots: 'Spots',
    'Free spots': 'Free spots',
    'No free spots': 'No free spots',
    Weekdays: 'Weekdays',
    'Repeat every N weeks': 'Repeat every N weeks',
    'Start date': 'Start date',
    'End date': 'End date',
    'Available for online booking': 'Available for online booking',
    'Hidden from online booking': 'Hidden from online booking',
    'This trainer provides no group services here':
      'This trainer provides no group services here',
    'Classes are generated ahead within the booking horizon. Dates when the trainer is busy or off schedule are skipped.':
      'Classes are generated ahead within the booking horizon. Dates when the trainer is busy or off schedule are skipped.',
    'Cancel this class?': 'Cancel this class?',
    'Every participant gets their coverage back — a card visit returns, a purchase is refunded. The trainer’s time is freed.':
      'Every participant gets their coverage back — a card visit returns, a purchase is refunded. The trainer’s time is freed.',
    Participants: 'Participants',
    'No participants': 'No participants',
    'Add participant': 'Add participant',
    'Existing client': 'Existing client',
    session_scheduled: 'Scheduled',
    session_completed: 'Finished',
    session_cancelled: 'Cancelled',
    'weekday short: sunday': 'Sun',
    'weekday short: monday': 'Mon',
    'weekday short: tuesday': 'Tue',
    'weekday short: wednesday': 'Wed',
    'weekday short: thursday': 'Thu',
    'weekday short: friday': 'Fri',
    'weekday short: saturday': 'Sat',
    'Scroll left': 'Scroll left',
    'Scroll right': 'Scroll right',

    Trainer: 'Trainer',
    'Guest name / phone': 'Guest name / phone',
    'Book without a client': 'Book without a client',
    'Free start times': 'Free start times',
    'Pick a trainer and a service first': 'Pick a trainer and a service first',
    'No free slots for this date': 'No free slots for this date',
    'This trainer provides no bookable services here':
      'This trainer provides no bookable services here',
    'The chosen service cannot start at {{time}}':
      'The chosen service cannot start at {{time}} — pick another start time',
    Book: 'Book',
  },
  uk: {
    ...Reservations.uk,
    ...CompanyEvents.uk,

    'Booking calendar': 'Календар записів',
    Today: 'Сьогодні',
    'No location available': 'Немає доступної локації',
    'No specialists scheduled': 'На цей день немає спеціалістів у графіку',
    'New booking': 'Новий запис',

    tab_booking: 'Запис',
    Block: 'Блокування',

    'Block time': 'Заблокувати час',
    'Leave a comment': 'Залишити коментар',
    'Edit block': 'Редагувати блокування',
    'Remove block': 'Зняти блокування',
    'Edit comment': 'Редагувати коментар',
    'Remove comment': 'Видалити коментар',
    Comment: 'Коментар',
    Text: 'Текст',
    Blocked: 'Заблоковано',
    'Group session': 'Групове заняття',
    'Group session at another location': 'Групове заняття на іншій локації',
    'Busy at another location': 'Зайнято на іншій локації',

    tab_group: 'Групове заняття',
    'New group class': 'Нове групове заняття',
    'Class details': 'Групове заняття',
    'Recurring class': 'Регулярне заняття',
    'Create class': 'Створити заняття',
    'Create schedule': 'Створити розклад',
    'Edit class': 'Редагувати заняття',
    'Cancel class': 'Скасувати заняття',
    'Start time': 'Час початку',
    Duration: 'Тривалість',
    Spots: 'Місць',
    'Free spots': 'Вільних місць',
    'No free spots': 'Місць немає',
    Weekdays: 'Дні тижня',
    'Repeat every N weeks': 'Повторювати кожні N тижнів',
    'Start date': 'Дата початку',
    'End date': 'Дата завершення',
    'Available for online booking': 'Доступно для онлайн-запису',
    'Hidden from online booking': 'Приховано з онлайн-запису',
    'This trainer provides no group services here':
      'Цей тренер не проводить тут групових послуг',
    'Classes are generated ahead within the booking horizon. Dates when the trainer is busy or off schedule are skipped.':
      'Заняття створюються наперед у межах горизонту запису. Дати, коли тренер зайнятий або не працює, пропускаються.',
    'Cancel this class?': 'Скасувати це заняття?',
    'Every participant gets their coverage back — a card visit returns, a purchase is refunded. The trainer’s time is freed.':
      'Кожен учасник отримує оплату назад — відвідування повертається на картку, покупку буде повернено. Час тренера звільняється.',
    Participants: 'Учасники',
    'No participants': 'Учасників немає',
    'Add participant': 'Додати учасника',
    'Existing client': 'Наявний клієнт',
    session_scheduled: 'Заплановане',
    session_completed: 'Завершене',
    session_cancelled: 'Скасоване',
    'weekday short: sunday': 'Нд',
    'weekday short: monday': 'Пн',
    'weekday short: tuesday': 'Вт',
    'weekday short: wednesday': 'Ср',
    'weekday short: thursday': 'Чт',
    'weekday short: friday': 'Пт',
    'weekday short: saturday': 'Сб',
    'Scroll left': 'Прокрутити ліворуч',
    'Scroll right': 'Прокрутити праворуч',

    Trainer: 'Тренер',
    'Guest name / phone': "Ім'я / телефон гостя",
    'Book without a client': 'Записати без клієнта',
    'Free start times': 'Вільний час',
    'Pick a trainer and a service first': 'Спочатку оберіть тренера та послугу',
    'No free slots for this date': 'Немає вільних слотів на цю дату',
    'This trainer provides no bookable services here':
      'Цей тренер не надає тут послуг для запису',
    'The chosen service cannot start at {{time}}':
      'Обрана послуга не може початись о {{time}} — оберіть інший час початку',
    Book: 'Записати',
  },
};
